import React, { useState, useEffect } from "react";
import "./updateModal.css";
import { toast } from "react-toastify";
import { updateOrganisationDetails, fetchAllProviders } from "../../../config/LiveApi";
import ReactSelect from "react-select";
import ConfirmModal from "./ConfirmModal";

const UpdateModal = ({ updateModalData, setIsUpdateModalOpen, token }) => {
  const [formData, setFormData] = useState(updateModalData);
  const [providersName, setProvidersName] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);

  // Store original data for comparison
  const [originalData] = useState(updateModalData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSelectChange = (fieldName) => (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: selectedOption.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if any data has changed
    const hasChanges = Object.keys(formData).some(
      (key) => formData[key] !== originalData[key]
    );

    if (hasChanges) {
      setConfirmModal(true);
    } else {
      toast.info("No changes detected.");
    }
  };

  const handleUpdateSubmit = async () => {
    if (!token) {
      toast.error("Token is missing. Please log in again.");
      return;
    }

    try {
      const response = await updateOrganisationDetails(
        formData.id,
        formData,
        token
      );

      if (response.success) {
        toast.success("Organisation updated successfully!");
        setIsUpdateModalOpen(false);
        window.location.reload();
      } else {
        toast.error("Failed to update organisation.");
      }
    } catch (error) {
      console.error("Error updating organisation:", error);
      toast.error("Error updating organisation.");
    }
  };

  const handleCancelConfirm = () => {
    setFormData(originalData);
    setConfirmModal(false);
  };

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const response = await fetchAllProviders(token);
        const providerName = response.data.providers;
        setProvidersName(providerName);
      } catch (error) {
        console.error("Error fetching providers:", error);
      }
    };

    fetchProviders();
  }, [token]);

  const statusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];

  const mapProvidersToOptions = (providers) =>
    providers.map((p) => ({
      label: `${p.providerName}_${p.orgName}`,
      value: p.providerName,
    }));

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Update Organization Details</h3>
        <form onSubmit={handleSubmit} className="dialog-data">
          <p className="label-data">Organization Name:</p>
          <input
            type="text"
            name="orgName"
            value={formData.orgName || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Organization Domain URL:</p>
          <input
            type="text"
            name="orgDomainURL"
            value={formData.orgDomainURL || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Organization Company Name:</p>
          <input
            type="text"
            name="orgCompanyName"
            value={formData.orgCompanyName || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Organization Phone Number:</p>
          <input
            type="text"
            name="orgPhoneNumber"
            value={formData.orgPhoneNumber || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Org GSTIN :</p>
          <input
            type="text"
            name="orgGSTIN"
            value={formData.orgGSTIN || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Organization Address :</p>
          <input
            type="text"
            name="orgAddress"
            value={formData.orgAddress || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Organization Logo :</p>
          <input
            type="text"
            name="orgLogo"
            value={formData.orgLogo || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">IP Address - 01 :</p>
          <input
            type="text"
            name="ip01"
            value={formData.ip01 || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">IP Address - 02 :</p>
          <input
            type="text"
            name="ip02"
            value={formData.ip02 || ""}
            onChange={handleInputChange}
          />
          <p className="label-data">Status:</p>
          <ReactSelect
            name="isActive"
            value={statusOptions.find(
              (option) => option.value === formData.isActive
            )}
            onChange={(selectedOption) =>
              setFormData({
                ...formData,
                isActive: selectedOption.value,
              })
            }
            options={statusOptions}
          />
          {/* <p className="label-data">Payin Provider Name:</p>
          <ReactSelect
            name="payinProviderName"
            value={
              mapProvidersToOptions(providersName).find(
                (option) => option.value === formData.payinProviderName
              ) || null
            }
            onChange={handleSelectChange("payinProviderName")}
            options={mapProvidersToOptions(providersName)}
          />
          <p className="label-data">Payout Provider Name:</p>
          <ReactSelect
            name="payoutProviderName"
            value={
              mapProvidersToOptions(providersName).find(
                (option) => option.value === formData.payoutProviderName
              ) || null
            }
            onChange={handleSelectChange("payoutProviderName")}
            options={mapProvidersToOptions(providersName)}
          /> */}

          <div className="modal-buttons">
            <button type="submit">Update</button>
            <button type="button" onClick={() => setIsUpdateModalOpen(false)}>
              Cancel
            </button>
          </div>
        </form>
      </div>

      {confirmModal && (
        <ConfirmModal
          handleUpdateSubmit={handleUpdateSubmit}
          handleCancelConfirm={handleCancelConfirm}
          orgName={formData.orgName}
        />
      )}
    </div>
  );
};

export default UpdateModal;
